module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/ma-collage-42aa53deae4fbad85ae9269b7ade7e72.jpg";